"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateTenant = exports.tenantSchema = void 0;
var zod = _interopRequireWildcard(require("zod"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const tenantSchema = exports.tenantSchema = zod.string().regex(/^[A-Za-z]{2}$/).transform(val => val.toLowerCase());

/**
 * Validates the provided tenant against the tenant schema.
 *
 * @param tenant - The tenant to validate. It can be undefined.
 * @returns The lowercased validated tenant if the validation is successful, otherwise undefined.
 */
const validateTenant = tenant => {
  const result = tenantSchema.safeParse(tenant);
  if (result.success) {
    return result.data;
  }
  return undefined;
};
exports.validateTenant = validateTenant;
//# sourceMappingURL=validateTenant.js.map